// extracted by mini-css-extract-plugin
module.exports = {"logo":"softwareBlock-module--logo--2pfIE","flexContainer":"softwareBlock-module--flex-container--36VC1","logoBig":"softwareBlock-module--logo-big--3YAKv"};